<template>
  <NuxtLayout :name="layoutName" :navbar-color="layoutNavbarColor" :footer-color="layoutFooterColor">
    <div v-if="story">
      <HeroScrollTrustedAi v-if="!isMobile" class="hero__desktop" />
      <div class="hero__mobile">
        <StoryblokComponent
          v-for="childBlok in story.content.hero"
          :key="childBlok._uid"
          :blok="childBlok"
        />
      </div>
      <StoryblokComponent
        v-for="childBlok in story.content.body"
        :key="childBlok._uid"
        :blok="childBlok"
      />
    </div>
  </NuxtLayout>
</template>

<script setup lang="ts">
import { gsap } from 'gsap'
definePageMeta({
  scrollToTop: true,
})

useScrollBlock({
  blockUntilMounted: true,
})

const { isMobile } = useDevice()

const queryParams = {
  resolve_relations: ['sb-infinite-marquee.members'],
}
const { story } = await useFetchStory('trusted-ai', {
  apiOptions: {
    ...queryParams,
  },
})

useCustomHead(story)

onMounted(() => {
  gsap
    .fromTo(
      '#ai-hero-loader-overlay',
      {
        opacity: 1,
      },
      {
        opacity: 0,
        duration: 0.8,
      },
    )
    .then(() => {
      document.querySelector('#ai-hero-loader-overlay')?.remove()
    })
})
const { layoutName, layoutNavbarColor, layoutFooterColor } = useLayout<any>(story)
</script>

<style lang="scss" scoped>
.hero {
  &__desktop {
    display: none;

    @media (min-width: $breakpoint-lg) {
      display: block;
    }
  }

  &__mobile {
    display: block;

    @media (min-width: $breakpoint-lg) {
      display: none;
    }
  }

  &__loader-overlay {
    width: 100%;
    height: calc(100vh - var(--header-height));
    z-index: 1000;
    background-color: white;
    position: fixed;
    top: var(--header-height);
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
